import { TabIconsEnum } from "./tabIconsEnum";
import {
  BandageIcon,
  FoodIcon,
  GadgetsIcon,
  GridIcon,
  MedTabletIcon,
  MenuIcon,
  PillIcon,
  Repair4Icon,
  SmartphoneIcon,
  SocketIcon,
  TabletIcon,
} from "@/shared/icons";

export const tabIconsList = {
  [TabIconsEnum.ALL]: GridIcon,
  [TabIconsEnum.PRODUCT]: FoodIcon,
  [TabIconsEnum.HOUSEHOLD]: Repair4Icon,
  [TabIconsEnum.TECH]: GadgetsIcon,
  [TabIconsEnum.OTHER]: MenuIcon,
  [TabIconsEnum.SMARTPHONE]: SmartphoneIcon,
  [TabIconsEnum.TABLET]: TabletIcon,
  [TabIconsEnum.ELECTRONIC]: SocketIcon,
  [TabIconsEnum.PILLS]: PillIcon,
  [TabIconsEnum.FIRSTAID]: BandageIcon,
  [TabIconsEnum.EQUIPMENT]: MedTabletIcon,
};
